/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-10-01
 * @brief EHP Check Sheet 관리 개발
 *
 ********************************************************************/
import React from "react";
import * as CUTIL from "../../../../utils/commUtils";
//component
import NoSpgView from "../common/NoSpgView";
import SpgCheckList from "./SpgCheckList";
import SpgCheckNewList from "./SpgCheckNewList";
/**
 * @brief EHP Check Sheet 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function CheckCRUD(props) {
    //const [isMobile, setIsMobile] = useState(false);
    //const [adminType, setAdminType] = useState("ZONE"); // ZONE, SUBZONE, ROOM
    //props
    const versionList = props.versionList;
    const spgVersion = props.spgVersion;
    //
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    return (React.createElement(React.Fragment, null,
        ((workMode === "INIT") || (CUTIL.isnull(spgVersion) === null)) && React.createElement(NoSpgView, { isMobile: props.isMobile, setIsMobile: props.setIsMobile, selTree: selTree, setSelTree: props.setSelTree, 
            //setAdminType={props.setAdminType}
            workMode: props.workMode, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin }),
        (selTree.spg.spgName.length > 0)
            && (workMode === "LIST")
            && (spgVersion)
            && React.createElement(SpgCheckList, { isMobile: props.isMobile, setIsMobile: props.setIsMobile, selTree: selTree, setSelTree: props.setSelTree, adminType: props.adminType, 
                //setAdminType={props.setAdminType}
                workMode: props.workMode, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin, 
                //
                //pageInfo={props.pageInfo}
                //setPageInfo={props.setPageInfo}
                versionList: props.versionList, spgVersion: props.spgVersion, setSpgVersion: props.setSpgVersion }),
        (selTree.spg.spgName.length > 0)
            && (workMode === "NLIST")
            /*&&(spgVersion)*/
            && React.createElement(SpgCheckNewList, { isMobile: props.isMobile, setIsMobile: props.setIsMobile, selTree: selTree, setSelTree: props.setSelTree, adminType: props.adminType, 
                //setAdminType={props.setAdminType}
                workMode: props.workMode, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin, 
                //
                //pageInfo={props.pageInfo}
                //setPageInfo={props.setPageInfo}
                versionList: props.versionList, spgVersion: props.spgVersion, setSpgVersion: props.setSpgVersion })));
}
;
export default CheckCRUD;
